import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import TextField from '@material-ui/core/TextField'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import Autocomplete from '@material-ui/lab/Autocomplete'
import clsx from 'clsx'
import { categoriesStyles } from 'components/ElementsTree/styles/categoriesPaneStyles'
import { ProfessionalDisciplineInner } from 'models/category'
import React, { ChangeEvent } from 'react'

interface DisciplineSelectorProps {
    /** Callback invoked when a category is selected. */
    handleDisciplineChange: (
        _: ChangeEvent<{}>,
        values: ProfessionalDisciplineInner
    ) => void
    /** list of all discipline data  */
    disciplineData: ProfessionalDisciplineInner[]

    /** selected discipline object  */
    selectedDiscipline: ProfessionalDisciplineInner

    /** custom react node for collapse icon. */
    collapseIcon: React.ReactNode
}
const DisciplineSelector = ({
    handleDisciplineChange,
    disciplineData,
    selectedDiscipline,
    collapseIcon,
}: DisciplineSelectorProps) => {
    const classes = categoriesStyles()

    return (
        <GridItem className={classes.disciplineContainerLeftPane}>
            <Autocomplete
                data-testid="disciplineWrapper"
                className={classes.selectDisciplineLeftPane}
                noOptionsText="No Discipline"
                options={disciplineData}
                getOptionSelected={(
                    option: ProfessionalDisciplineInner,
                    value: ProfessionalDisciplineInner
                ) => option.name === value.name}
                selectOnFocus={false}
                value={selectedDiscipline}
                popupIcon={
                    <ArrowDropDownIcon
                        data-testid="arrowIcon"
                        fontSize="small"
                        className={classes.dropIcon}
                    />
                }
                getOptionLabel={(option: ProfessionalDisciplineInner) =>
                    option.name
                }
                onChange={handleDisciplineChange}
                disableClearable={true}
                blurOnSelect={true}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        data-testid="disciplineSelector"
                        size="small"
                        fullWidth={true}
                        inputProps={{
                            ...params.inputProps,
                            'aria-autocomplete': 'none',
                            autoComplete: 'off',
                            'data-testid': 'disciplineInput',
                        }}
                        variant="outlined"
                        InputLabelProps={{
                            ...params.InputLabelProps,
                            className: clsx(classes.text, classes.selectLabel),
                        }}
                        InputProps={{
                            ...params.InputProps,
                            classes: {
                                input: classes.selectInner,
                                root: classes.root,
                            },
                        }}
                    />
                )}
            />
            {collapseIcon}
        </GridItem>
    )
}

export default DisciplineSelector
